var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "folder_off_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#folder_off_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M36.292 31.582 11.417 6.665h3.375a3.291 3.291 0 0 1 2.333.959L19.5 9.999h13.834a3.21 3.21 0 0 1 2.354.979 3.21 3.21 0 0 1 .979 2.354v16.667c0 .305-.028.59-.084.854a2.231 2.231 0 0 1-.291.729Zm-29.625 1.75a3.21 3.21 0 0 1-2.354-.98A3.21 3.21 0 0 1 3.333 30v-20c0-.917.327-1.702.98-2.354a3.21 3.21 0 0 1 2.354-.98L10 10H5.334l-3-3a1.629 1.629 0 0 1-.48-1.146 1.551 1.551 0 0 1 .48-1.188c.305-.305.694-.458 1.166-.458s.861.153 1.167.458l30.666 30.667c.334.333.494.722.48 1.167a1.678 1.678 0 0 1-.521 1.166 1.758 1.758 0 0 1-1.167.48c-.444.013-.833-.146-1.166-.48l-4.334-4.333H6.667Z"
}))));
export default SvgFolderOff;